import React from 'react'
import styles from './Footer.module.scss'
import logo from '../../image/Header/logo (1).svg'

const Footer = ({isOpen, isRus}) => {

    return (
        <footer className={styles.main}>
            <div className={styles.container}>
                <div className={styles.box}>
                    <img className={styles.logo} src={logo} alt = 'логотип'/>
                </div>
                <p className={styles.link_politics} tupe= 'button' onClick={isOpen}>{ isRus  ? 'Политика конфиденциальности' : 'Privacy policy'}</p>
                <div className={styles.box}>
                    <p className={styles.text}>&#169; {new Date().getFullYear()} { isRus  ? 'Все права защищены.' : 'All rights reserved.'}</p>
                    <a className={styles.link_developer} target='_blank' rel='noopener noreferrer' href='https://tihonov-studio.ru/' aria-label='сайт тихонова дмитрия'>
                        <p className={styles.text}>{ isRus  ? 'Разработано:' : 'Developed by:'}<span> TD</span></p>
                    </a>
                </div>
            </div>
        </footer>
    )
}

export default Footer